export enum NetworkMemberRole {
  Administrator = 0,
  BaseMember = 1,
}
